import { DatePipe } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { HipoModel } from 'src/app/models/hipo/HipoModel';
import { IFilterHipoModel } from 'src/app/models/interfaces/hipo/IFilterHipoModel';
import { IHipoModel } from 'src/app/models/interfaces/hipo/IHipoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HipoService {
  private configUrl = [environment.apiGatewayUrl, 'hipos'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

  getList(
    model: IFilterHipoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<SearchResultModel<HipoModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anios.length > 0) {
      queryParams.push(`anios=${model.anios.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.fechaInicioEvento){
      queryParams.push(`fechaInicioEvento=${this.datepipe.transform(model.fechaInicioEvento, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinEvento){
      queryParams.push(`fechaFinEvento=${this.datepipe.transform(model.fechaFinEvento, 'yyyy-MM-dd')}`);
    }

    if(model.categorias.length > 0){
      queryParams.push(`categorias=${model.categorias.join(',')}`);
    }

    if(model.tiposregla.length > 0){
      queryParams.push(`tiposregla=${model.tiposregla.join(',')}`);
    }

    if (model.tipoaccidente.length > 0) {
      queryParams.push(`tipoaccidente=${model.tipoaccidente.join(',')}`);
    }

    if (model.proyecto !== '') {
      queryParams.push(`proyecto=${model.proyecto}`);
    }
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get<SearchResultModel<HipoModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  exportList(
    model: IFilterHipoModel
    // codigo: string,
    // contratista: string,
    // estado: number,
    // fecha: Date
  ): Observable<HttpResponse<Blob>> {
    let queryParams: string[] = new Array<string>();
    
    if (model.sedes.length > 0) {
      queryParams.push(`sedes=${model.sedes.join(',')}`);
    }

    if (model.anios.length > 0) {
      queryParams.push(`anios=${model.anios.join(',')}`);
    }

    if (model.contratista !== '') {
      queryParams.push(`contratista=${model.contratista}`);
    }

    if(model.fechaInicioEvento){
      queryParams.push(`fechaInicioEvento=${this.datepipe.transform(model.fechaInicioEvento, 'yyyy-MM-dd')}`);
    }

    if(model.fechaFinEvento){
      queryParams.push(`fechaFinEvento=${this.datepipe.transform(model.fechaFinEvento, 'yyyy-MM-dd')}`);
    }

    if(model.categorias.length > 0){
      queryParams.push(`categorias=${model.categorias.join(',')}`);
    }

    if(model.tiposregla.length > 0){
      queryParams.push(`tiposregla=${model.tiposregla.join(',')}`);
    }

    if (model.proyecto !== '') {
      queryParams.push(`proyecto=${model.proyecto}`);
    }
    if(model.idCompania != 0){
      queryParams.push(`companias=${model.idCompania}`);
    }

    return this.http.get(`${this.configUrl}/exportar?${queryParams.join('&')}`, { observe: 'response', responseType: 'blob'});
  }

  getById(id: number): Observable<HipoModel> {
    return this.http.get<HipoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IHipoModel) {
    return this.http.post<ActionResultModel>(`${this.configUrl}`, model);
  }

  update(model: IHipoModel) {
    return this.http.put<ActionResultModel>(
      `${this.configUrl}/${model.idHipo}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ActionResultModel>(`${this.configUrl}/${id}`);
  }
}
